import {
  Component,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnInit
} from '@angular/core';
import { Question } from '../../../../../classes';
import { Subscription } from 'rxjs';

@Component({
  selector: 'question-text',
  templateUrl: './question-text.component.html',
  styleUrls: ['./question-text.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionTextComponent implements OnInit {
  @Input() question: Question;
  subscriptions: Subscription[] = [];
  constructor(private cdRef: ChangeDetectorRef) {}
  ngOnInit() {
    this.subscriptions.push(
      this.question
        .getChildTracker('text')
        .onContentUpdate.subscribe(() => this.refreshView())
    );
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  private refreshView() {
    this.cdRef.detectChanges();
  }
}
